import { LoadingSkeleton, tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { Divider, Stack } from '@mui/material'

export const EnergyEfficiencyLoader = () => {
    return (
        <Stack direction="column" width="100%" gap={tokens.SizingSpacing300} alignItems="center">
            <Typography variant="headline3" color={tokens.ColorTextBoldest}>
                <LoadingSkeleton height="24px" width="180px" variant="rounded" />
            </Typography>
            <Stack direction="column" width="100%" gap={tokens.SizingSpacing400} alignItems="center">
                <Stack direction="row" gap={tokens.SizingSpacing050}>
                    <LoadingSkeleton count={9} height="40px" width="33px" variant="rounded" />
                </Stack>
                <Stack direction="column" gap={tokens.SizingSpacing050} width="100%">
                    <Divider sx={{ width: '100%', borderColor: tokens.ColorBorderDefault }} />
                    <Stack
                        direction="row"
                        gap={tokens.SizingSpacing200}
                        height="100px"
                        marginTop={tokens.SizingSpacing050}
                        alignItems="center"
                    >
                        <Stack direction="column" width="100%" gap={tokens.SizingSpacing050}>
                            <LoadingSkeleton height="28px" width="80px" variant="rounded" />
                            <LoadingSkeleton height="20px" width="105px" variant="rounded" />
                        </Stack>
                        <Divider sx={{ borderColor: tokens.ColorBorderDefault, height: '100%' }} />
                        <Stack direction="column" width="100%" gap={tokens.SizingSpacing050}>
                            <LoadingSkeleton height="28px" width="80px" variant="rounded" />
                            <LoadingSkeleton height="20px" width="105px" variant="rounded" />
                        </Stack>
                        <Divider sx={{ borderColor: tokens.ColorBorderDefault, height: '100%' }} />
                        <Stack direction="column" width="100%" gap={tokens.SizingSpacing050}>
                            <LoadingSkeleton height="28px" width="80px" variant="rounded" />
                            <LoadingSkeleton height="20px" width="105px" variant="rounded" />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}
